module.exports = __webpack_public_path__ + "img/logo.c4dca4b8.png";